/**
 * Ordering Content Type
 * A content type wrapping the ordering element with title/description
 */

// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    orderingContentSchema,
    defaultOrderingContentConfig,
    defaultOrderingContentData,
    defaultOrderingI18n,
    normalizeOrderingContentData,
    serializableOrderingContentData,
    type OrderingContent,
    type OrderingContentData,
    type OrderingContentExercise,
    type OrderingContentConfig,
    type OrderingLayoutConfig,
    type OrderingScoringConfig,
    type OrderingPlayerView,
} from './schema';
export {
    gradeOrderingContentComposite,
    normalizeOrderingContentAnswer,
    validateOrderingContentComposite,
    type OrderingContentCompositeAnswer,
} from './compositeGrading';

// Components
export { OrderingContentEdit, type OrderingContentEditProps } from './OrderingContentEdit';
export { OrderingContentPlayer, type OrderingContentPlayerProps } from './OrderingContentPlayer';

// Default export
export { orderingContentSchema as default } from './schema';

export { countOrderingQuestions, orderingQuestionCounter } from './questionCount';
